export default __webpack_public_path__ + "static/media/20 - The Hill Waves.a66ffd20.jpg";